import { render, staticRenderFns } from "./DictionaryMngt.vue?vue&type=template&id=32e9f6ee"
import script from "./DictionaryMngt.vue?vue&type=script&lang=js"
export * from "./DictionaryMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports